import { useAuth } from '@/contexts/auth-context';
import type { Brand } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { currentBrandKeys } from './current-brand-keys';

export const fetchCurrentBrand = async (
  expectedBrandId: string | null | undefined,
  signal?: AbortSignal
): Promise<Brand> => {
  const { data } = await api.get<Brand>('/dashboard/brands/me/details', { signal });
  if (!expectedBrandId || data.id !== expectedBrandId) {
    throw new Error('The selected brand changed while its details were loading.');
  }
  return data;
};

export const useCurrentBrandQuery = (enabled = true) => {
  const { user } = useAuth();
  return useQuery<Brand, Error>({
    queryKey: currentBrandKeys.detail(user?.currentBrandId),
    queryFn: ({ signal }) => fetchCurrentBrand(user?.currentBrandId, signal),
    enabled: enabled && !!user?.currentBrandId,
  });
};
